<button class="tile" (click)="clicked.emit()">
  <div class="tile-icon-slot">
    <ng-content></ng-content>
  </div>
  <h3 class="tile-title">{{ title }}</h3>
  <p class="tile-caption">{{ caption }}</p>
  <capra-badge *ngIf="badgeText" type="green" class="phase-badge" [text]="badgeText"></capra-badge>
</button>
